import React, { ReactElement } from 'react';

import { ContentProvider } from '@interstellar/react-app-content';
import { Routes, Route, Navigate } from '@interstellar/react-app-routing';

import * as routes from './manifest';
import useAppConfig from '../containers/appConfig/useAppConfig';
import content from '../content';
import AboutBusiness from '../pages/aboutBusiness/AboutBusiness';
import AboutYou from '../pages/aboutYou/AboutYou';
import AlreadyRegistered from '../pages/alreadyRegistered/AlreadyRegistered';
import FullSignatoryPage from '../pages/fullSignatoryPage/FullSignatoryPage';
import IdvWrapper from '../pages/idvWrapper';
import IdvHardFailure from '../pages/idvHardFailure/IdvHardFailure';
import IdvErrorPage from '../pages/idvErrorPage/IdvErrorPage';
import MayfairAccountError from '../pages/mayfairAccountError/MayfairAccountError';
import MobileNumberMissing from '../pages/MobileNumberMissing/MobileNumberMissing';
import Redirect from '../pages/redirect/Redirect';
import RegistrationApproval from '../pages/registrationApproval/RegistrationApproval';
import RegistrationInProgress from '../pages/registrationInProgress/RegistrationInProgress';
import SessionTimedOut from '../pages/sessionTimedOut/SessionTimedOut';
import SmsOtp from '../pages/smsOtp/SmsOtp';
import SmsOtpAuthorise from '../pages/smsOtpAuthorise/SmsOtpAuthorise';
import SubmitYourRegistration from '../pages/submitYourRegistration/SubmitYourRegistration';
import SwitchToMobile from '../pages/switchToMobile/SwitchToMobile';
import TechnicalErrorPage from '../pages/technicalErrorPage/TechnicalErrorPage';
import ThankYou from '../pages/thankYou/ThankYou';
import ThreeStepsToRegisterApproval from '../pages/threeStepsToRegisterApproval/ThreeStepsToRegisterApproval';
import ThreeStepsToRegisterDelegateAccess from '../pages/threeStepsToRegisterDelegateAccess/ThreeStepsToRegisterDelegateAccess';
import ThreeStepsToRegisterDesktop from '../pages/threeStepsToRegisterDesktop/ThreeStepsToRegisterDesktop';
import ThreeStepsToRegisterIdVerify from '../pages/threeStepsToRegisterIdVerify/ThreeStepsToRegisterIdVerify';
import TriageDeviceSwitch from '../pages/triageDeviceSwitch/TriageDeviceSwitch';
import TriageStartPage from '../pages/triageStartPage/TriageStartPage';
import UnableToVerify from '../pages/unableToVerify/UnableToVerify';

function App(): ReactElement {
  const brand = useAppConfig().BRAND_NAME;

  return (
    <Routes>
      <Route
        path={routes.Home}
        element={<Navigate to={routes.GetStarted} replace />}
      />
      <Route
        path={routes.GetStarted}
        element={
          <ContentProvider value={content({ brand }).triageStartPage}>
            <TriageStartPage />
          </ContentProvider>
        }
      />
      <Route
        path={routes.FullSignatoryPage}
        element={
          <ContentProvider value={content({ brand }).fullSignatoryPage}>
            <FullSignatoryPage />
          </ContentProvider>
        }
      />
      <Route
        path={routes.ThreeStepsToRegisterDelegateAccess}
        element={
          <ContentProvider
            value={content({ brand }).threeStepsToRegisterDelegateAccess}
          >
            <ThreeStepsToRegisterDelegateAccess />
          </ContentProvider>
        }
      />
      <Route
        path={routes.ThreeStepsToRegisterApproval}
        element={
          <ContentProvider
            value={content({ brand }).threeStepsToRegisterApproval}
          >
            <ThreeStepsToRegisterApproval />
          </ContentProvider>
        }
      />
      <Route
        path={routes.ThreeStepsToRegisterDesktop}
        element={
          <ContentProvider
            value={content({ brand }).threeStepsToRegisterDesktop}
          >
            <ThreeStepsToRegisterDesktop />
          </ContentProvider>
        }
      />
      <Route
        path={routes.ThreeStepsToRegisterIdVerify}
        element={
          <ContentProvider
            value={content({ brand }).threeStepsToRegisterIdVerify}
          >
            <ThreeStepsToRegisterIdVerify />
          </ContentProvider>
        }
      />
      <Route
        path={routes.RegistrationApproval}
        element={
          <ContentProvider value={content({ brand }).registrationApproval}>
            <RegistrationApproval />
          </ContentProvider>
        }
      />
      <Route
        path={routes.TriageDeviceSwitch}
        element={
          <ContentProvider value={content({ brand }).triageDeviceSwitch}>
            <TriageDeviceSwitch />
          </ContentProvider>
        }
      />
      <Route
        path={routes.SwitchToMobileQrScan}
        element={
          <ContentProvider value={content({ brand }).switchToMobile}>
            <SwitchToMobile />
          </ContentProvider>
        }
      />
      <Route
        path={routes.Redirect}
        element={
          <ContentProvider value={content({ brand }).redirect}>
            <Redirect />
          </ContentProvider>
        }
      />
      <Route
        path={routes.AboutTheBusiness}
        element={
          <ContentProvider value={content({ brand }).aboutBusiness}>
            <AboutBusiness />
          </ContentProvider>
        }
      />
      <Route
        path={routes.MayfairAccountError}
        element={
          <ContentProvider value={content({ brand }).mayfairAccountError}>
            <MayfairAccountError />
          </ContentProvider>
        }
      />
      <Route
        path={routes.AboutYou}
        element={
          <ContentProvider value={content({ brand }).aboutYou}>
            <AboutYou />
          </ContentProvider>
        }
      />
      <Route
        path={routes.MobileNumberMissing}
        element={
          <ContentProvider value={content({ brand }).mobileNumberMissing}>
            <MobileNumberMissing />
          </ContentProvider>
        }
      />
      <Route
        path={routes.AlreadyRegistered}
        element={
          <ContentProvider value={content({ brand }).alreadyRegistered}>
            <AlreadyRegistered />
          </ContentProvider>
        }
      />
      <Route
        path={routes.TechnicalErrorPage}
        element={
          <ContentProvider value={content({ brand }).technicalErrorPage}>
            <TechnicalErrorPage />
          </ContentProvider>
        }
      />
      <Route
        path={routes.RegistrationInProgress}
        element={
          <ContentProvider value={content({ brand }).registrationInProgress}>
            <RegistrationInProgress />
          </ContentProvider>
        }
      />
      <Route
        path={routes.SmsOtp}
        element={
          <ContentProvider value={content({ brand }).smsOtp}>
            <SmsOtp />
          </ContentProvider>
        }
      />
      <Route
        path={routes.SmsOtpAuthorize}
        element={
          <ContentProvider value={content({ brand }).smsOtpAuthorise}>
            <SmsOtpAuthorise />
          </ContentProvider>
        }
      />
      <Route
        path={routes.SessionTimedOut}
        element={
          <ContentProvider value={content({ brand }).sessionTimedOut}>
            <SessionTimedOut />
          </ContentProvider>
        }
      />
      <Route
        path={routes.UnableToVerify}
        element={
          <ContentProvider value={content({ brand }).unableToVerify}>
            <UnableToVerify />
          </ContentProvider>
        }
      />
      <Route
        path={routes.IdvWrapper}
        element={
          <ContentProvider value={content({ brand }).idvWrapper}>
            <IdvWrapper />
          </ContentProvider>
        }
      />
      <Route
        path={routes.IdvHardFailure}
        element={
          <ContentProvider value={content({ brand }).idvHardFailure}>
            <IdvHardFailure />
          </ContentProvider>
        }
      />
      <Route
        path={routes.IdvErrorPage}
        element={
          <ContentProvider value={content({ brand }).idvErrorPage}>
            <IdvErrorPage />
          </ContentProvider>
        }
      />
      <Route
        path={routes.SubmitYourRegistration}
        element={
          <ContentProvider value={content({ brand }).submitYourRegistration}>
            <SubmitYourRegistration />
          </ContentProvider>
        }
      />
      <Route
        path={routes.ThankYou}
        element={
          <ContentProvider value={content({ brand }).thankYou}>
            <ThankYou />
          </ContentProvider>
        }
      />
    </Routes>
  );
}

export default App;
